import React, { useState } from "react";

// Mock database example
const mockMembers = {
  A123: { name: "John Doe", status: "Active", membersince: "1981" },
  B456: { name: "Jane Smith", status: "Expired", membersince: "1981" },
  C789: { name: "Alice Johnson", status: "Active", membersince: "1981" },
  S725: { name: "Salman Saeed", status: "Active", membersince: "1981" },
};

const MembershipVerify = ({ onBack }) => {
  const [code, setCode] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const handleVerify = (e) => {
    e.preventDefault();
    const trimmedCode = code.trim().toUpperCase();

    if (trimmedCode.length !== 4) {
      setError("Please enter exactly 4 characters or digits.");
      setResult(null);
      return;
    }

    const member = mockMembers[trimmedCode];
    if (member) {
      setResult(member);
      setError("");
    } else {
      setResult(null);
      setError("Membership code not found.");
    }
  };

  return (
    <section className="section" id="membership-verify">
      <h2>Verify Membership</h2>
      <form onSubmit={handleVerify}>
        <label>
          Enter Membership Code (4 characters):
          <input
            type="text"
            maxLength={4}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        </label>
        <br />
        <button type="submit" className="button">
          Verify
        </button>
        <button
          type="button"
          className="button"
          style={{ marginLeft: "10px", backgroundColor: "#555" }}
          onClick={onBack}
        >
          Back
        </button>
      </form>

      {error && <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>}

      {result && (
        <div style={{ marginTop: "1rem", color: "var(--primary)" }}>
          <p>
            <strong>Name:</strong> {result.name}
          </p>
          <p>
            <strong>Member Since:</strong> {result.membersince}
          </p>
          <p>
            <strong>Status:</strong> {result.status}
          </p>{" "}
        </div>
      )}
    </section>
  );
};

export default MembershipVerify;
